import { createSelector } from 'reselect';
import { denormalize } from 'normalizr';
import { vodContent } from 'app-webtech-core/schemas';
import { subselect } from './root';
import { propertiesSelector } from './properties';

const vodItemsSelector = createSelector([propertiesSelector], ({ result = [], entities }) =>
  result.length && entities.vodCategories
    ? denormalize(result, [vodContent.VodCategorySchema], entities)
    : [],
);

export const vodContentItemsSelector = subselect(vodItemsSelector);
